import React, { Fragment, useEffect, useState } from "react";
import Hero from "../../components/hero";
import AboutS2 from "../../components/AboutS2";
import Footer from "../../components/footer";
import OurCompanies from "../../components/OurCompanies";
import PartnerSection from "../../components/PartnerSection";
import ProjectSection4 from "../../components/ProjectSection4";
import Scrollbar from "../../components/scrollbar";
import Service5 from "../../components/Service5";
import { GET_MENUS_ALL_NESTED } from "../../constant/constants";

const HomePage = () => {
  const [homeId, setHomeId] = useState();
  const [serviceId, setServiceId] = useState();

  useEffect(() => {
    fetch(`${GET_MENUS_ALL_NESTED}`)
      .then((response) => response.json())
      .then((data) => {
        data.menus.find((e) => e.name === "Home" && setHomeId(e.id));
        data.menus.find((e) => e.name === "Service" && setServiceId(e.id));
      })
      .catch(() => {});
  }, []);

  return (
    <Fragment>
      <Hero />
      <AboutS2 id={homeId} />
      <Service5 id={serviceId} />
      <PartnerSection id={homeId} />
      <ProjectSection4 id={homeId} />

      {/* ✅ Fixed Google Map Embed */}
      <div style={{ width: "100%", height: "450px", marginTop: "40px" }}>
        <iframe
          title="FMQ Establishment Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d48774.59130468319!2d90.34396112167973!3d23.73355759999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b85ec831169f%3A0x879b88698cc087d7!2sM%2FS.%20F.M.Q.%20Establishment!5e1!3m2!1sen!2sbd!4v1761048329634!5m2!1sen!2sbd"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      <Scrollbar />
      <Footer />
    </Fragment>
  );
};

export default HomePage;
